<template>
  <div class="md-layout text-center login_biz">
    <div class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
      <form @submit.prevent="login">
        <login-card>
          <div class="logoWpr" slot="title">
            <img src="/img/logo-sm.png" alt="Bizminer small logo" />
          </div>
          <h1 slot="title" class="title login-title">Login</h1>
          
          <p slot="title" class="sub_title" v-if="!isOnLibraryWithoutAccess()">
            Enter your details below to continue
          </p>

          <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto" slot="content" v-if="isOnLibraryWithoutAccess()">
            <p slot="title" class="sub_title">Your current IP isn't affiliated with any academic account. Please contact your customer service representative!</p>
          </div>

          <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto" slot="content" v-else>
            <div v-if="ipDetected">
              <md-button class="md-info md-round background-purple" @click="redirectSearch">
                Academic Library Detected, Access Now
              </md-button>
            </div>
            <sso-buttons />
            <label>Email</label>
            <md-field label="Email" text-label="Email" :class="{ 'md-invalid': $v.email.$error }">
              <label class="font-size-small">.</label>
              <!-- <md-icon>email</md-icon>
              <label>Email</label> -->
              <md-input v-model="$v.email.$model" name="email" />
              <span class="md-error" v-if="!$v.email.required">
                This field is required
              </span>
            </md-field>

            <label>Password</label>
            <md-field label="Password" text-label="Password" :class="{ 'md-invalid': $v.password.$error }">
              <!-- <md-icon>lock_outline</md-icon>
              <label>Password</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.password.$model" type="password" name="password" />
              <span class="md-error" v-if="!$v.email.required">
                This field is required
              </span>
            </md-field>

            <div class="md-form-group md-invalid">
              <router-link :to="{ name: 'ForgotPassword' }" class="text-left forgot-pass-link">Forgot password?
              </router-link>
            </div>
            <div>
              <md-button class="md-info md-round dark-blue-color" type="submit" slot="footer">
                Lets Go
              </md-button>
            </div>

            <p slot="footer" v-if="!ipDetected" class="sub_title text-center ">
              Don't have an account?
              <router-link class="dark-blue-color" to="register">Register
              </router-link>
            </p>
            <p slot="footer" class="color-black text-left forgot-pass-link text-center">
              <small class="color-black ">{{ this.userIP }}</small>
            </p>
          </div>
          
        </login-card>
      </form>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import SsoButtons from "@/components/auth/SsoButtons.vue";
import formMixin from "@/mixins/form-mixin";
import sha256 from "crypto-js/sha256";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import axios from "axios";

export default {
  components: {
    LoginCard,
    SsoButtons,
  },
  mixins: [formMixin],
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
    academicIP: function () {
      return localStorage.getItem("academicIP");
    },
    ...mapState({
      user: (state) => state.user,
      subTotal: (state) => state.cart.subTotal,
      academic: (state) => state.user.academic,
      academicIPState: (state) => state.user.academic_ip,
    }),
  },

  mounted() {
    this.checkSessionId();
    let isAlreadyRefresh = localStorage.getItem("refreshLogin");

    if (!isAlreadyRefresh) {
      localStorage.setItem("refreshLogin", true);
      window.location.reload();
    }
    this.getUserIP();
    this.doIPDetection();
  },
  updated() {
    this.getUserIP();
    this.doIPDetection();
  },
  watch: {
    academicIP() { this.doIPDetection(); },
    academicIPState() { this.doIPDetection(); },
  },
  data: () => ({
    email: "",
    password: "",
    userIP: null,
    ipDetected: true,
    currentSession: null,
  }),
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    async checkSessionId() {
      this.currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      if (!this.currentSession) {
        this.$store.dispatch("getRandomString", 20).then(async (res) => {
          this.currentSession = res;
          await localStorage.setItem(
            "vue-authenticate.vueauth_access_token",
            this.currentSession
          );
          //this.redirectSearch();
        });
      }
    },

    isOnLibrary() {
      // library-bizminer-com.proxy.library.emory.edu | library.bizminer.com
      let host = window.location.hostname;
      const index = host.indexOf(".");
      if (index === -1) {
        return false; // Not finding the "." character.
      }

      let subdomain = host.substring(0, index);

      return subdomain == "library" || subdomain == "library-bizminer-com";
    },

    isOnLibraryWithoutAccess() {
      return this.isOnLibrary() && !this.ipDetected;
    },

    console_log(msg) {
      console.log(msg);
    },
    async getUserIP() {
      this.$store.dispatch("authenticateUser");

      this.userIP = localStorage.getItem("userIP");
    },

    doIPDetection() {
      if (this.academicIP || this.academicIPState) this.ipDetected = true;
      else this.ipDetected = false;

      if (this.ipDetected) {
        if (window.origin == "https://library.bizminer.com") {
          this.redirectSearch();
        }
      }
    },

    redirectSearch() {
      this.$store
        .dispatch("authenticateUser")
        .then((res) => {
          this.$router.push({ name: "Search" });
        })
        .catch((error) => {
          this.$router.push({ name: "Search" });
        });
    },
    async login() {
      this.$v.$touch();
      if (!this.email || !this.password) {
        this.$store.dispatch("alerts/error", "Please enter inputs!");
        return false;
      }
      this.$store.dispatch("getRandomString", 20).then(async (res) => { // TODO: this needs some looking at. This is why sessions keep resetting.
        const user = {
          session_id: res,
          username: this.email,
          password: sha256(this.password).toString(),
        };

        const requestOptions = {
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
          },
        };

        let login_succeeded = false;
        try {
          await this.$store.dispatch("login", { user, requestOptions });
          login_succeeded = true;
        } catch (e) {
          //this.console_log(e);

          let params = {
            session_id: res,
            backend: 0,
            url: "/login",
            extra: e.name + "::" + e.message,
            endpoint_url: "",
            trace: e.stack + " ::agent = " + navigator.userAgent,
            file: "file",
            line: "",
          };
          axios
            .post(
              process.env.VUE_APP_API_BASE_URL + "/user/feedback/error",
              {},
              {
                params: params,
              }
          );

          if(e.message == "login_no_users") {
            await this.$store.dispatch('alerts/error', 'Invalid credentials!');
          } else if(e.message == "login_no_users_1") {
            await this.$store.dispatch('alerts/error', 'Invalid credentials!');
          } else if(e.message == "login_no_users_2") {
            await this.$store.dispatch('alerts/error', 'Invalid credentials!');
          } else if(e.message == "user_not_verified") {
            await this.$store.dispatch('alerts/error', 'Email not verified!');
          } else if(e.message == "login_many_users") {
            await this.$store.dispatch('alerts/error', 'Can\'t log in, contact your sales representative!');
          } else if(e.message == "login_access_disabled") {
            await this.$store.dispatch('alerts/error', 'Can\'t log in, contact your sales representative!');
          } else if(e.message == "login_existing_session") {
            await this.$store.dispatch('alerts/error', 'Unable to log in / already logged in!');
          } else if(e.message == "login_invalid_request") {
            await this.$store.dispatch('alerts/error', 'Invalid parameters!');
          } else if(e.message == "invalid_request_password") {
            await this.$store.dispatch('alerts/error', 'Invalid credentials!');
          } else if(e.message == "Network Error") {
            await this.$store.dispatch('alerts/error', 'Network error!');
          } else {
            await this.$store.dispatch('alerts/error', 'Unable to log in / unknown! ' + e.message);
          }

          //await this.$store.dispatch("alerts/error", "ERROR : " + e.message);
        }

        if(login_succeeded) {
          try {
            this.$store.commit("PS_SET_ID", null);
            this.$store.commit("PS_SET_PRICE", null);
            this.$store.commit("PS_SET_TOTAL", null);
          } catch (e) {
            //console.log(e);
            //this.console_log(e);
            await this.$store.dispatch("alerts/error", "Failed fully initializing app!");
          }
        }
      });
    },
  },
};
</script>
<style lang="scss"></style>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}
</style>
